/*=========================================================================================
  File Name: mutations.js
  Description: Vuex Store - mutations
  ----------------------------------------------------------------------------------------
  Item Name: POS SYSTEM
  Author: SpeedCodeLabs
  Author URL: http://www.speedcodelabs.com
==========================================================================================*/

const mutations = {
  REMOVE_FILTERDATAS(state, payload) {
    var datastore = state.filterDatas;
    datastore.brand = '';
    datastore.category = '';
    datastore.supplier = '';
    datastore.status = '';
    datastore.shop = '';
    datastore.toShop = '';
    datastore.fromShop = '';
    datastore.customer = '';
    datastore.product = '';
    datastore.biller = '';
    datastore.saleType = '';
    datastore.customerType = '';
    datastore.warehouse = '';
    datastore.productquery = '';
    datastore.warehousequery = '';
    datastore.purchaseStatus = '';
    datastore.purchaseOrderstatus = '';
    datastore.paymentStatus = '';
    datastore.transferStatus = '';
    datastore.amount = '';
    datastore.type = '';
    datastore.paymenType = '';
    datastore.cheqStatus = '';
    (datastore.cheqFor = ''), (datastore.expenseCategory = '');
    datastore.expnseCategoryquery = '';
    datastore.brandquery = '';
    datastore.categoryquery = '';
    datastore.shopquery = '';
    datastore.toShopquery = '';
    datastore.fromShopquery = '';
    datastore.customerquery = '';
    datastore.billerquery = '';
    datastore.start = '';
    datastore.end = '';
    datastore.supplierquery = '';
    datastore.search = '';
    datastore.incomeFor = '';

    datastore.expenseFor = '';
    // state.filterDatas = datastore;
  },

  UPDATE_PAGINATION_PAGE_SIZE(state, payload) {
    var datastore = state.productperpageItemsize;
    datastore = payload;
    state.productperpageItemsize = datastore;
  },
  UPDATE_IS_REMOVE_DATA_CAECHE(state, payload) {
    var datastore = state.filterDatas.isRemoveDatecaeche;
    datastore = payload;
    state.filterDatas.isRemoveDatecaeche = datastore;
  },
  UPDATE_IS_NEW_PAGE(state, payload) {
    var datastore = state.filterDatas.isrouteNewPage;
    datastore = payload;
    state.filterDatas.isrouteNewPage = datastore;
  },
  UPDATE_SEARCH_FILTER_SIZE(state, payload) {
    var datastore = state.filterDatas.search;
    datastore = payload;
    state.filterDatas.search = datastore;
  },
  UPDATE_STOCK_TRANFER_WAREHOUSE_FILTER(state, payload) {
    var datastore = state.StockTransferWarehouse;
    datastore = payload;
    state.StockTransferWarehouse = datastore;
  },
  UPDATE_STOCK_TRANFER_WAREHOUSE_QUERY_FILTER(state, payload) {
    var datastore = state.StockTransferWarehouseQuery;
    datastore = payload;
    state.StockTransferWarehouseQuery = datastore;
  },

  UPDATE_DATE_END_FILTER(state, payload) {
    var datastore = state.filterDatas.end;
    datastore = payload;
    state.filterDatas.end = datastore;
  },
  UPDATE_DATE_START_FILTER(state, payload) {
    var datastore = state.filterDatas.start;
    datastore = payload;
    state.filterDatas.start = datastore;
  },
  UPDATE_BILLER_QUERY_FILTER(state, payload) {
    var datastore = state.filterDatas.billerquery;
    datastore = payload;
    state.filterDatas.billerquery = datastore;
  },
  UPDATE_CUSTOMER_QUERY_FILTER(state, payload) {
    var datastore = state.filterDatas.customerquery;
    datastore = payload;
    state.filterDatas.customerquery = datastore;
  },
  UPDATE_SHOP_QUERY_FILTER(state, payload) {
    var datastore = state.filterDatas.shopquery;
    datastore = payload;
    state.filterDatas.shopquery = datastore;
  },
  UPDATE_TO_SHOP_QUERY_FILTER(state, payload) {
    var datastore = state.filterDatas.toShopquery;
    datastore = payload;
    state.filterDatas.toShopquery = datastore;
  },
  UPDATE_FROM_SHOP_QUERY_FILTER(state, payload) {
    var datastore = state.filterDatas.fromShopquery;
    datastore = payload;
    state.filterDatas.fromShopquery = datastore;
  },
  UPDATE_SUPPLIER_QUERY_FILTER(state, payload) {
    var datastore = state.filterDatas.supplierquery;
    datastore = payload;
    state.filterDatas.supplierquery = datastore;
  },
  UPDATE_CATEGORY_QUERY_FILTER(state, payload) {
    var datastore = state.filterDatas.categoryquery;
    datastore = payload;
    state.filterDatas.categoryquery = datastore;
  },
  UPDATE_BRAND_QUERY_FILTER(state, payload) {
    var datastore = state.filterDatas.brandquery;
    datastore = payload;
    state.filterDatas.brandquery = datastore;
  },
  UPDATE_EXPENSE_FOR_FILTER(state, payload) {
    var datastore = state.filterDatas.expenseFor;
    datastore = payload;
    state.filterDatas.expenseFor = datastore;
  },

  UPDATE_INCOME_FOR_FILTER(state, payload) {
    var datastore = state.filterDatas.incomeFor;
    datastore = payload;
    state.filterDatas.incomeFor = datastore;
  },

  UPDATE_EXPENSE_CATEGORY_FILTER(state, payload) {
    var datastore = state.filterDatas.expenseCategory;
    datastore = payload;
    state.filterDatas.expenseCategory = datastore;
  },
  UPDATE_EXPENSE_CATEGORY_QUERY_FILTER(state, payload) {
    var datastore = state.filterDatas.expnseCategoryquery;
    datastore = payload;
    state.filterDatas.expnseCategoryquery = datastore;
  },
  UPDATE_CHEQUE_STATUS_FILTER(state, payload) {
    var datastore = state.filterDatas.cheqStatus;
    datastore = payload;
    state.filterDatas.cheqStatus = datastore;
  },
  UPDATE_CHEQUE_FOR_FILTER(state, payload) {
    var datastore = state.filterDatas.cheqFor;
    datastore = payload;
    state.filterDatas.cheqFor = datastore;
  },
  UPDATE_PAYMENT_FORM_FILTER(state, payload) {
    var datastore = state.filterDatas.type;
    datastore = payload;
    state.filterDatas.type = datastore;
  },
  UPDATE_PAYMENT_TYPE_FILTER(state, payload) {
    var datastore = state.filterDatas.paymenType;
    datastore = payload;
    state.filterDatas.paymenType = datastore;
  },
  UPDATE_TRANSFER_STATUS_FILTER(state, payload) {
    var datastore = state.filterDatas.transferStatus;
    datastore = payload;
    state.filterDatas.transferStatus = datastore;
  },
  UPDATE_TOTAL_AMOUNT_FILTER(state, payload) {
    var datastore = state.filterDatas.amount;
    datastore = payload;
    state.filterDatas.amount = datastore;
  },
  UPDATE_PAYMENT_STATUS_FILTER(state, payload) {
    var datastore = state.filterDatas.paymentStatus;
    datastore = payload;
    state.filterDatas.paymentStatus = datastore;
  },
  UPDATE_PURCHASE_ORDER_STATUS_FILTER(state, payload) {
    var datastore = state.filterDatas.purchaseOrderstatus;
    datastore = payload;
    state.filterDatas.purchaseOrderstatus = datastore;
  },
  UPDATE_PURCHASE_STATUS_FILTER(state, payload) {
    var datastore = state.filterDatas.purchaseStatus;
    datastore = payload;
    state.filterDatas.purchaseStatus = datastore;
  },
  UPDATE_PRODUCT_QUERY_FILTER(state, payload) {
    var datastore = state.filterDatas.productquery;
    datastore = payload;
    state.filterDatas.productquery = datastore;
  },
  UPDATE_WAREHOUSE_AUTOCOMPLETE_QUERY_FILTER(state, payload) {
    var datastore = state.filterDatas.warehousequery;
    datastore = payload;
    state.filterDatas.warehousequery = datastore;
  },
  UPDATE_WAREHOUSE_FILTER(state, payload) {
    var datastore = state.filterDatas.warehouse;
    datastore = payload;
    state.filterDatas.warehouse = datastore;
  },
  UPDATE_CUSTOMER_TYPE_FILTER(state, payload) {
    var datastore = state.filterDatas.customerType;
    datastore = payload;
    state.filterDatas.customerType = datastore;
  },
  UPDATE_CUSTOMERTYPE_AUTOCOMPLETE_QUERY_FILTER(state, payload) {
    var datastore = state.filterDatas.customerTypequery;
    datastore = payload;
    state.filterDatas.customerTypequery = datastore;
  },
  UPDATE_SALETYPE_FILTER(state, payload) {
    var datastore = state.filterDatas.saleType;
    datastore = payload;
    state.filterDatas.saleType = datastore;
  },
  UPDATE_PRODUCT_FILTER(state, payload) {
    var datastore = state.filterDatas.product;
    datastore = payload;
    state.filterDatas.product = datastore;
  },
  UPDATE_SHOP_FILTER(state, payload) {
    var datastore = state.filterDatas.shop;
    datastore = payload;
    state.filterDatas.shop = datastore;
  },
  UPDATE_TO_SHOP_FILTER(state, payload) {
    var datastore = state.filterDatas.toShop;
    datastore = payload;
    state.filterDatas.toShop = datastore;
  },
  UPDATE_FROM_SHOP_FILTER(state, payload) {
    var datastore = state.filterDatas.fromShop;
    datastore = payload;
    state.filterDatas.fromShop = datastore;
  },
  UPDATE_CUSTOMER_FILTER(state, payload) {
    var datastore = state.filterDatas.customer;
    datastore = payload;
    state.filterDatas.customer = datastore;
  },
  UPDATE_BILLER_FILTER(state, payload) {
    var datastore = state.filterDatas.biller;
    datastore = payload;
    state.filterDatas.biller = datastore;
  },
  UPDATE_STATUS_FILTER(state, payload) {
    var datastore = state.filterDatas.status;
    datastore = payload;
    state.filterDatas.status = datastore;
  },
  UPDATE_BRAND_FILTER(state, payload) {
    var datastore = state.filterDatas.brand;
    datastore = payload;
    state.filterDatas.brand = datastore;
  },
  UPDATE_SUPPLIER_FILTER(state, payload) {
    var datastore = state.filterDatas.supplier;
    datastore = payload;
    state.filterDatas.supplier = datastore;
  },
  UPDATE_CATEGORY_FILTER(state, payload) {
    var datastore = state.filterDatas.category;
    datastore = payload;
    state.filterDatas.category = datastore;
  },
  UPDATE_LOAD_URL(state, payload) {
    var datastore = state.repoUrl;
    datastore = payload;
    state.repoUrl = datastore;
  },
  UPDATE_PRINT_CHEQUE(state, payload) {
    var chequeDetails = state.chequeDetails;
    chequeDetails = payload;
    state.chequeDetails = chequeDetails;
  },
  UPDATE_KEY_SHORTCUTS_CUSTOMER_CREATE(state, payload) {
    var keyShortcuts = state.keyShortcuts.add_customer;
    keyShortcuts = payload;
    state.keyShortcuts.add_customer = keyShortcuts;
  },
  UPDATE_KEY_SHORTCUTS_BRAND_VIEW(state, payload) {
    var keyShortcuts = state.keyShortcuts.brand_view;
    keyShortcuts = payload;
    state.keyShortcuts.brand_view = keyShortcuts;
  },
  UPDATE_KEY_SHORTCUTS_CATEGORY_VIEW(state, payload) {
    var keyShortcuts = state.keyShortcuts.category_view;
    keyShortcuts = payload;
    state.keyShortcuts.category_view = keyShortcuts;
  },
  UPDATE_KEY_SHORTCUTS_REFRESH(state, payload) {
    var keyShortcuts = state.keyShortcuts.refresh;
    keyShortcuts = payload;
    state.keyShortcuts.refresh = keyShortcuts;
  },
  UPDATE_KEY_SHORTCUTS_CHANGE_SHOP(state, payload) {
    var keyShortcuts = state.keyShortcuts.change_shop;
    keyShortcuts = payload;
    state.keyShortcuts.change_shop = keyShortcuts;
  },
  UPDATE_KEY_SHORTCUTS_CHANGE_CUSTOMER(state, payload) {
    var keyShortcuts = state.keyShortcuts.change_customer;
    keyShortcuts = payload;
    state.keyShortcuts.change_customer = keyShortcuts;
  },
  UPDATE_KEY_SHORTCUTS_SEARCH_PRODUCT(state, payload) {
    var keyShortcuts = state.keyShortcuts.search_product;
    keyShortcuts = payload;
    state.keyShortcuts.search_product = keyShortcuts;
  },
  UPDATE_KEY_SHORTCUTS_CUSTOMER_VIEW(state, payload) {
    var keyShortcuts = state.keyShortcuts.suspend_sale;
    keyShortcuts = payload;
    state.keyShortcuts.suspend_sale = keyShortcuts;
  },
  UPDATE_KEY_SHORTCUTS_SUSBEND_SALES_VIEW(state, payload) {
    var keyShortcuts = state.keyShortcuts.suspend_sale;
    keyShortcuts = payload;
    state.keyShortcuts.suspend_sale = keyShortcuts;
  },
  UPDATE_KEY_SHORTCUTS_QUOTATION_VIEW(state, payload) {
    var keyShortcuts = state.keyShortcuts.quotation_view;
    keyShortcuts = payload;
    state.keyShortcuts.quotation_view = keyShortcuts;
  },
  UPDATE_KEY_SHORTCUTS_PREVIOUS_SALES_VIEW(state, payload) {
    var keyShortcuts = state.keyShortcuts.previous_sales;
    keyShortcuts = payload;
    state.keyShortcuts.previous_sales = keyShortcuts;
  },
  UPDATE_KEY_SHORTCUTS_PAYMENT_VIEW(state, payload) {
    var keyShortcuts = state.keyShortcuts.payment_view;
    keyShortcuts = payload;
    state.keyShortcuts.payment_view = keyShortcuts;
  },
  UPDATE_KEY_SHORTCUTS_BILL_VIEW(state, payload) {
    var keyShortcuts = state.keyShortcuts.bill_view;
    keyShortcuts = payload;
    state.keyShortcuts.bill_view = keyShortcuts;
  },
  UPDATE_KEY_SHORTCUTS(state, payload) {
    var keyShortcuts = state.keyShortcuts;
    keyShortcuts = payload;
    state.keyShortcuts = keyShortcuts;
  },
  CALCULATOR_CURRENT(state, payload) {
    var current = state.currentCalculation;
    current = payload;
    state.currentCalculation = current;
  },

  UPDATE_PDFLOADNG_VISIBLE(state, payload) {
    var LoadingBar = state.LoadingBar;
    LoadingBar = payload;
    state.LoadingBar = LoadingBar;
  },
  UPDATE_PDF_HEADERS(state, payload) {
    var Columnheaders = state.Columnheaders;
    Columnheaders = payload;
    state.Columnheaders = Columnheaders;
  },
  UPDATE_PDF_DATAS(state, payload) {
    var StoreDatas = state.StoreDatas;
    StoreDatas = payload;
    state.StoreDatas = StoreDatas;
  },
  UPDATE_PDF_VISIBLE(state, payload) {
    var iSPdfShow = state.iSPdfShow;
    iSPdfShow = payload;
    state.iSPdfShow = iSPdfShow;
  },
  UPDATE_PDF_TITLE(state, payload) {
    var modulename = state.modulename;
    modulename = payload;
    state.modulename = modulename;
  },
  UPDATE_PURCHASE_TOTAL(state, payload) {
    //Total Purchase set state
    var purchaseTotal = state.purchaseTotal;
    purchaseTotal = payload.total;
    state.purchaseTotal = purchaseTotal;
    //Total Discount set state
    var discountTotal = state.discountTotal;
    discountTotal = payload.discount;
    state.discountTotal = discountTotal;
    //Purchase Paid set state
    var purchasePaid = state.purchasePaid;
    purchasePaid = payload.paid;
    state.purchasePaid = purchasePaid;
  },

  UPDATE_SALE_TOTAL(state, payload) {
    //Total sale set state
    var salesTotal = state.salesTotal;
    salesTotal = payload.total;
    state.salesTotal = salesTotal;
    //Net Amount sale set state
    var salesNet = state.salesNet;
    salesNet = payload.grandtotal;
    state.salesNet = salesNet;
    //Discount Amount sale set state
    var salesDiscount = state.salesDiscount;
    salesDiscount = payload.discount;
    state.salesDiscount = salesDiscount;
  },
  REMOVE_PRODUCTBULK(state, payload) {
    var BulkEdit = state.BulkEdit;

    BulkEdit.splice(payload.index, 1);
    state.BulkEdit = BulkEdit;
  },
  REMOVE_SELECTEDDATA(state, payload) {
    var SelectedDatas = state.SelectedDatas;

    SelectedDatas.splice(payload.index, 1);
    state.SelectedDatas = SelectedDatas;
  },
  UPDATE_SELECTEDROWS(state, payload) {
    var SelectedDatas = state.SelectedDatas;

    SelectedDatas.push(payload);
    state.SelectedDatas = SelectedDatas;
  },
  CLEAR_ALL(state, payload) {
    var BulkEdit = state.BulkEdit;

    BulkEdit = [];
    state.BulkEdit = BulkEdit;
  },
  CLEAR_ALL_ROWS(state, payload) {
    var SelectedDatas = state.SelectedDatas;

    SelectedDatas = [];
    state.SelectedDatas = SelectedDatas;
  },

  UPDATE_PAGESIZE(state, payload) {
    var productpagesize = state.productpagesize;

    productpagesize = payload.val;
    state.productpagesize = productpagesize;
  },
  UPDATE_WAREHOUSEVIEW(state, payload) {
    var WarehouseView = state.WarehouseView;

    WarehouseView = payload.name;
    state.WarehouseView = WarehouseView;
  },
  UPDATE_LOGO(state, payload) {
    var imagelink = state.imagelink;

    imagelink = payload.link;
    state.imagelink = imagelink;
  },
  UPDATE_SHOPVIEW(state, payload) {
    var ShopView = state.ShopView;
    ShopView = payload.name;
    state.ShopView = ShopView;
  },
  UPDATE_PRODUCTBULK(state, payload) {
    var BulkEdit = state.BulkEdit;

    BulkEdit.push(payload);
    state.BulkEdit = BulkEdit;
  },

  UPDATE_PRODUCT_CODE(state, payload) {
    var BulkEdit = state.BulkEdit;
    BulkEdit[payload.index].id = payload.id;
    BulkEdit[payload.index].code = payload.code;
    BulkEdit[payload.index].name = payload.name;
    BulkEdit[payload.index].min_price = payload.min_price;
    state.BulkEdit = BulkEdit;
  },
  UPDATE_PRODUCT_NAME(state, payload) {
    var BulkEdit = state.BulkEdit;
    BulkEdit[payload.index].id = payload.id;
    BulkEdit[payload.index].code = payload.code;
    BulkEdit[payload.index].name = payload.name;
    BulkEdit[payload.index].min_price = payload.min_price;
    state.BulkEdit = BulkEdit;
  },
  UPDATE_PRODUCT_MIN_PRICE(state, payload) {
    var BulkEdit = state.BulkEdit;
    BulkEdit[payload.index].id = payload.id;
    BulkEdit[payload.index].code = payload.code;
    BulkEdit[payload.index].name = payload.name;
    BulkEdit[payload.index].min_price = payload.min_price;
    state.BulkEdit = BulkEdit;
  },
  ADD_PRODUCT(state, payload) {},
  UPDATE_PAYMENT_CHEQUEBANK(state, payload) {
    var PaymentDatas = state.PaymentDatas;
    PaymentDatas[payload.index].cheque_bank = payload.bank;
    state.PaymentDatas = PaymentDatas;
  },
  UPDATE_PAYMENT_CHEQUETYPE(state, payload) {
    var PaymentDatas = state.PaymentDatas;
    PaymentDatas[payload.index].cheque_type = payload.type;
    state.PaymentDatas = PaymentDatas;
  },
  UPDATE_PAYMENT_CHEQUENUMBER(state, payload) {
    var PaymentDatas = state.PaymentDatas;
    PaymentDatas[payload.index].cheque_no = payload.number;
    state.PaymentDatas = PaymentDatas;
  },
  UPDATE_PAYMENT_CHEQUEDATE(state, payload) {
    var PaymentDatas = state.PaymentDatas;
    PaymentDatas[payload.index].cheque_date = payload.date;
    state.PaymentDatas = PaymentDatas;
  },
  UPDATE_TOTAL_AMOUNT(state, payload) {
    var payments = state.totalSalesAmount;

    payments = payload.amount;

    state.totalSalesAmount = payments;

    if (state.PaymentDatas.length == 1) {
      var datas = state.PaymentDatas;

      datas[0].amount = payload.amount;

      state.PaymentDatas = datas;
    }
  },

  UPDATE_PAYMENT_AMOUNT(state, payload) {
    var payments = state.PaymentDatas;

    payments[payload.index].amount = payload.amount;

    state.PaymentDatas = payments;
  },
  UPDATE_PAYMENT_TYPE(state, payload) {
    var payments = state.PaymentDatas;

    payments[payload.index].payment_type = payload.paymentType;
    if (payload.paymentType == 'Cheque') {
      payments[payload.index].cheque_no = '';
      payments[payload.index].cheque_date = payload.date;
      payments[payload.index].cheque_bank = '';
      payments[payload.index].cheque_type = 'cash';
    }

    state.PaymentDatas = payments;
  },
  REMOVE_PAYMENT_TYPE(state, payload) {
    var PaymentDatas = state.PaymentDatas;

    PaymentDatas.splice(payload.index, 1);
    state.PaymentDatas = PaymentDatas;
  },
  ADD_ANOTHER_PAYMENT_TYPE(state, payload) {
    var PaymentDatas = state.PaymentDatas;
    PaymentDatas.push({
      payment_type: 'Cash',
      payment_note: '',
      amount: 0,
    });
    state.PaymentDatas = PaymentDatas;
  },
  ADD_PRODUCT_NEW(state, payload) {
    var storedProducts = state.StoredProducts;
    storedProducts.push({
      productid: '',
      batches: '',
      units: '',
      available_Stocks: '',
      selectedProdct: {},
      selectedBatch: {},
      selectedUnit: {},
      ProductVisible: true,
      validateUnit: false,
      units: '',
      batch_id: '',
      unit_id: '',
      amount: 0,
      discount: 0,
      quantity: 0,
    });
    state.StoredProducts = storedProducts;
  },

  REMOVE_ALL(state, payload) {
    state.StoredProducts = [
      {
        productid: '',
        batches: '',
        available_Stocks: '',
        units: '',
        ProductVisible: true,
        validateUnit: false,
        selectedProdct: {},
        selectedBatch: {},
        selectedUnit: {},
        units: '',
        batch_id: '',
        unit_id: '',
        amount: 0,
        discount: 0,
        quantity: 0,
      },
    ];
    state.PaymentDatas = [
      {
        payment_type: 'Cash',
        payment_note: '',
        amount: '',
      },
    ];

    state.totalSalesAmount = null;
  },
  SUCCESS_SALE_CLEAR_DATAS(state, payload) {
    state.StoredProducts = [
      {
        productid: '',
        batches: '',
        units: '',
        available_Stocks: '',
        ProductVisible: true,
        validateUnit: false,
        selectedProdct: {},
        selectedBatch: {},
        selectedUnit: {},
        units: '',
        batch_id: '',
        unit_id: '',
        amount: 0,
        discount: 0,
        quantity: 0,
      },
    ];
    state.PaymentDatas = [
      {
        payment_type: 'Cash',
        payment_note: '',
        amount: '',
      },
    ];

    state.totalSalesAmount = null;
  },
  REMOVE_PRODUCT(state, payload) {
    var products = state.StoredProducts;

    products.splice(payload.index, 1);
    state.StoredProducts = products;
  },

  UPDATE_PRODUCT_DISCOUNT(state, payload) {
    var products = state.StoredProducts;
    products[payload.index].discount = payload.discount;
    state.StoredProducts = products;
  },
  UPDATE_PRODUCT_QUANTITY(state, payload) {
    var products = state.StoredProducts;
    products[payload.index].quantity = payload.quantity;
    state.StoredProducts = products;
  },
  UPDATE_PRODUCT_NEW_PRICE(state, payload) {
    var products = state.StoredProducts;
    products[payload.index].amount = payload.amount;
    state.StoredProducts = products;
  },
  ADD_PRODUCT_PRICE_PERTICULAR_PRODUCT(state, payload) {
    var products = state.StoredProducts;

    products[payload.index].unit_id = payload.item.id;
    products[payload.index].selectedUnit = payload.item;

    products[payload.index].batches = payload.item.batches;
    state.StoredProducts = products;
  },
  ADD_UNIT_PERTICULAR_PRODUCT(state, payload) {
    var products = state.StoredProducts;
    products[payload.index].batch_id = payload.item.id;
    products[payload.index].selectedBatch = payload.item;
    products[payload.index].amount = payload.item.selling_price;
    products[payload.index].available_Stocks = payload.item.available_stock;
    products[payload.index].validateUnit = true;

    state.StoredProducts = products;
  },
  ADD_PRODUCT(state, payload) {
    var products = state.StoredProducts;
    products[payload.index].quantity = payload.datas.quantity;
    products[payload.index].selectedProdct = payload.datas.selectedProdct;
    products[payload.index].productid = payload.datas.id;
    products[payload.index].batch_id = payload.datas.batch_id;
    products[payload.index].unit_id = payload.datas.unit_id;
    products[payload.index].units = payload.datas.unitList;
    products[payload.index].amount = payload.datas.amount;
    products[payload.index].discount = payload.datas.discount;
    products[payload.index].ProductVisible = false;

    state.StoredProducts = products;
  },
  UPDATE_SALES_PRODUCTS(state, payload) {
    state.StoredProducts = payload;
  },
  UPDATE_SALES_DETAILS(state, payload) {
    state.saleDetails = payload;
  },
  UPDATE_SALES_QUOTATION(state, payload) {
    state.saleQuotation = payload;
  },
  SET_COUNTRIES(state, payload) {
    state.countries = payload;
  },
  SET_PAGE_SIZE(state, payload) {
    state.productpagesize = payload;
  },
  SET_SERVER_MESSAGES(state, payload) {
    state.server_messages = payload;
  },
  SET_POS_URL(state, payload) {
    state.pos_url = payload;
  },

  SET_TIME_FORMATS(state, payload) {
    state.dateformat = payload.dateformat;
    state.timeformat = payload.timeformat;
    state.monthyearformat = payload.monthyearformat;
    state.yearonlyformat = payload.yearonlyformat;
  },
  SET_PAGINATION_SETTING(state, payload) {
    state.pagination_settings = payload;
  },

  SET_Calculator_SETTING(state, payload) {
    state.calculatorVisible = payload;
  },

  SET_BREADCRUMB(state, payload) {
    state.breadcrumb = payload;
  },
  SET_COLOR_MODE(state, payload) {
    state.theme = payload ? 'light' : 'dark';
  },
};
export default mutations;
